var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcMexcbt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 138.67 152.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "69.33 69.34 41.6 55.47 41.6 27.74 69.33 13.56 69.33 13.56 69.33 13.56 110.94 34.36 110.94 20.8 69.33 0 69.33 0 69.33 0 27.73 20.8 27.73 20.8 27.73 20.8 27.73 48.53 0 34.67 0 48.23 0 48.23 0 117.56 13.87 124.49 13.87 55.16 27.73 62.09 27.73 117.86 27.73 117.86 27.73 131.42 69.33 152.22 110.94 131.42 110.94 117.86 69.33 138.67 41.6 124.8 41.6 69.03 69.33 82.89 124.8 55.16 124.8 124.49 138.67 117.56 138.67 48.23 138.67 48.23 138.67 34.67 69.33 69.34"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMexcbt);
export default __webpack_public_path__ + "static/media/ic_mexcbt.6368d2a9ce7123293a665c335e66c6c9.svg";
export { ForwardRef as ReactComponent };